import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'BtnPairs',
  props: {
    isOkCancel: { type: Boolean },
    isSaveCancel: { type: Boolean },
    isSubmitCancel: { type: Boolean },
    isYesNo: { type: Boolean },
    isSearchReset: { type: Boolean },
    hideOk: { type: Boolean },
    hideSave: { type: Boolean },
    hideCancel: { type: Boolean },
    hideSubmit: { type: Boolean },
    hideYes: { type: Boolean },
    hideNo: { type: Boolean },
    hideSearch: { type: Boolean },
    hideReset: { type: Boolean },
    swapOrder: { type: Boolean }
  },
  emits: ["ok", "save", "cancel", "submit", "yes", "no", "search", "reset"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'ok')
    (e: 'save')
    (e: 'cancel')
    (e: 'submit')
    (e: 'yes')
    (e: 'no')
    (e: 'search')
    (e: 'reset')
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isOkCancel?: boolean, isSaveCancel?: boolean, isSubmitCancel?: boolean, isYesNo?: boolean, isSearchReset?: boolean, hideOk?: boolean, hideSave?: boolean, hideCancel?: boolean, hideSubmit?: boolean, hideYes?: boolean, hideNo?: boolean, hideSearch?: boolean, hideReset?: boolean, swapOrder?: boolean }






return { __sfc: true,props, emits }
}

})